import {
  Box,
  ButtonGroup,
  Container,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuList,
  useDisclosure
} from '@chakra-ui/react';
import Logo from './Logo';
import Navigation from './Navigation';
import ProfileModal from '@/profile/profile';
import {
  getIsGlobalAdmin,
  getIsGlobalAdminRole,
  getIsGlobalOperations,
  getIsImpersonating,
  getIsMyFFLRole,
  getIsPreferredReportsRole,
  getIsSearchOnlyRole,
  getIsStoreAdmin,
  getIsStoreAgent,
  getStoreData,
  getStoreId,
  getStoreListData,
  getUserName
} from '@/redux/app-selectors';
import CreateStore from './createStore';
import {
  callToGetStoreData,
  callToGetStoreList,
  callToStopImpersonateGlobalAdmin,
  setIsGlobalAdmin,
  setIsGlobalAdminRole,
  setIsMyFFLRole,
  setIsStoreAdmin,
  setIsStoreAdminRole,
  setStoreId
} from '@/redux/app-slice';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import cookie from 'js-cookie';
import { setTotalTransfersCount } from '@/queue/ducks/slice';
import { useMatch, useNavigate } from 'react-router-dom';
import {
  resetExploreSlice,
  setLicenseByZipQueryParams
} from '@/explore/ducks/slice';
import { IMPERSONATING_INFO, STOP_IMPERSONATING } from '@/utils/constants';
import { getIsUserInfo } from "../redux/app-selectors"
import AppConfig from '@/utils/app-config.mjs';
import getAccessTokenIstance from '@/utils/authentication';
import StoreSelect from './storeSelect';
import StoreChangeModal from './storeChangeModal';
import { fetchAuthSession, getCurrentUser, signOut, updateUserAttributes } from 'aws-amplify/auth';


export default function Header() {
  // const isDesktop = useBreakpointValue({ base: false, lg: true })
  const isGlobalAdmin = getIsGlobalAdmin();
  const isGlobalOperations = getIsGlobalOperations();
  const isGlobalAdminRole = getIsGlobalAdminRole();
  const isStoreAdmin = getIsStoreAdmin();
  const isStoreAgent = getIsStoreAgent();
  
  const userName = getUserName();
  const isMyFFLRole = getIsMyFFLRole();
  const isPreferredReportsRole = getIsPreferredReportsRole();
  const isSearchOnlyRole = getIsSearchOnlyRole();
  const match = useMatch('/transfers/:id');

  const storeId = getStoreId();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen:isOpenStoreChange, onOpen: onOpenStoreChange, onClose: onCloseStoreChange } = useDisclosure();
  const isImpersonating = getIsImpersonating();

  const navigate = useNavigate();
  const {
    isOpen: menuIsOpen,
    onOpen: menuOnOpen,
    onClose: menuOnClose
  } = useDisclosure();
  const dispatch = useDispatch();
  const storeData = getStoreData();
  const isGettingUserInfo = getIsUserInfo();
  
  const MYFFL_STORE_ID = import.meta.env.VITE_MYFFL_STORE_ID;
  console.log('MYFFL_STORE_ID: ', MYFFL_STORE_ID);
  const storeListData = (getStoreListData() ?? []).filter((item: { store_id: string }) => item.store_id !== MYFFL_STORE_ID);

  const [selectedStoreVal, setSelectedStoreVal] = useState({ store_id: '', store_name: '' });

  useEffect(() => {
    if (storeData && storeData.store_id) {
      setSelectedStoreVal({ store_id: storeData.store_id, store_name: storeData.name });
    }
  }, [storeData]);

  // const match = useMatch('/transfers/:id');

  const [userPermissions, setUserPermissions] = useState({})

  const refreshCognitoSession = async () => {
  try {
    // Force refresh and get new session
    const session = await fetchAuthSession({ forceRefresh: true });
    
    // Check if session is valid
    if (session.tokens) {
      return session;
    } else {
      throw new Error('No valid tokens in session');
    }
  } catch (error) {
    console.error('Error refreshing session:', error);
    // If refresh fails, user might need to re-authenticate
    throw error;
  }
};
  
  const onGetPermissions = async () => {
    try {
      await refreshCognitoSession();
      const accessTokenINstance = await getAccessTokenIstance();
      const userPermissions = accessTokenINstance.getUserPermissions()
      setUserPermissions(userPermissions);
      localStorage.setItem('savedUserPermissions', JSON.stringify(userPermissions));
    } catch (error) {
      console.error('Error getting permissions:', error);
    }
  }
  useEffect(() => {
    const currentPath = window.location.pathname;
    const isTransferDetailPage = /\/transfers\/\d+/.test(currentPath);

    if (!isTransferDetailPage) {
      onGetPermissions();
    }
  }, []);

  async function signOutFunction() {
    try {
      localStorage.setItem('clientType', '')
      await signOut({global: true});
      setTimeout(() => {
        dispatch(setIsStoreAdmin(false));
        dispatch(setIsStoreAdminRole(false));
        dispatch(setIsGlobalAdmin(false));
        dispatch(setIsGlobalAdminRole(false));
        dispatch(setStoreId(''));
        dispatch(resetExploreSlice());
        dispatch(setLicenseByZipQueryParams({ sortBy: 'preferred' }));
        dispatch(setTotalTransfersCount(0));
        dispatch({ type: 'RESET' });
        dispatch(setIsMyFFLRole(false));
        navigate('/');
        localStorage.setItem('savedUserPermissions', '');
        localStorage.setItem('globalAdminColumnState', '');
        localStorage.setItem('adminColumnState', '');
        // localStorage.setItem('savedIsOutbound', '');
      }, 1000);
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }
  

  const onClickStopImpersonate = () => {
    dispatch(callToStopImpersonateGlobalAdmin({ navigate }));
  }
  const isGlobalAdminImpersonating = () => {
    return cookie.get(AppConfig.cookieStoreIdName) && isImpersonating;
  };

  // Conditional logic to make profile api call if !globalAdmin 
  useEffect(() => {
    if (!isMyFFLRole && isGettingUserInfo && (!isGlobalAdmin || isGlobalAdminImpersonating())) {
      dispatch(callToGetStoreData());
      dispatch(callToGetStoreList());
    }
  }, [isGettingUserInfo, isGlobalAdmin, isMyFFLRole]);

  const profileMenu = [
    ...(isGlobalAdminImpersonating()
      ? [
        {
          label: STOP_IMPERSONATING,
          imageSrc: '/images/ui/stop.svg',
          onClick: onClickStopImpersonate
        }
      ]
      : []),
    {
      label: 'Logout',
      imageSrc: '/images/ui/logout.svg',
      onClick: signOutFunction
    }
  ];

  const forceRefreshUser = async () => {
  try {
    // Force refresh the auth session (equivalent to bypassCache: true)
    await fetchAuthSession({ forceRefresh: true });
    
    // Get the current user
    const user = await getCurrentUser();
    
    if (match) {
      window.location.replace(`/transfers/`);
    } else {
      navigate(0);
    }
    
    return user;
  } catch (error) {
    console.error("Error refreshing user:", error);
    throw error;
  }
};

  async function updateUserAttributesV6(value: any) {
  try {
    onOpenStoreChange();
    const result = await updateUserAttributes({
      userAttributes: {
        'custom:storeId': value.store_id,
      }
    });
    
    await forceRefreshUser();
  } catch (error) {
    console.error('Error updating user attributes:', error);
  }
}

  const onChangeStore = (value: any) => {
    setSelectedStoreVal(value);
    updateUserAttributesV6(value);
    // localStorage.setItem('savedUserPermissions', '');
    // localStorage.setItem('savedIsOutbound', '');
  };

  const isDesktop = window.innerWidth > 1200;

  return (
    <Box className={'Header'} as="section" background={'#0C1E46'}>
      <Box
        as="nav"
        bg="bg-accent"
        color="on-accent"
        className="headers-navigation"
      >
        <Container className={'main'}>
          <Flex className="flex-container">
            <HStack spacing="4" className='header-logo-wrapper'>
              <Logo />
            </HStack>
            {!isMyFFLRole && (
              <Box className="navigation-wrapper">
                <Navigation
                  isGlobalAdmin={isGlobalAdmin}
                  isGlobalOperations={isGlobalOperations}
                  isStoreAdmin={isStoreAdmin}
                  onClick={menuOnClose}
                  isGlobalAdminRole={isGlobalAdminRole}
                  userPermissions={userPermissions}
                  isStoreAgent={isStoreAgent}
                />
              </Box>
            )}
            {/* {isDesktop() ? ( */}
            <HStack spacing="4" className="header-profile">
              {(!isMyFFLRole && isGettingUserInfo && (!isGlobalAdmin || isGlobalAdminImpersonating()) && storeListData?.length > 1) && (
                <StoreSelect selectedOption={selectedStoreVal} options={storeListData} onChangeDropdown={onChangeStore} />
              )}
              <ButtonGroup
                variant="ghost-on-accent"
                spacing="1"
                color={'white'}
              >
                {/* <Link to={'/explore'}>
                    <IconButton
                      icon={<FiSearch fontSize="1.25rem" />}
                      aria-label="Search"
                    />
                  </Link>
                  <IconButton
                    icon={<FiHelpCircle fontSize="1.25rem" />}
                    aria-label="Help Center"
                  /> */}
              </ButtonGroup>
              <Menu
                autoSelect={false}
                isOpen={menuIsOpen}
                onOpen={menuOnOpen}
                onClose={menuOnClose}
              >
                <MenuButton
                  className="header-icon-button"
                  as={IconButton}
                  isActive={menuIsOpen}
                ></MenuButton>
                <MenuList className="profile-dropdown">
                  <div className="profile-dropdown__inner">
                    <div className="profile-dropdown__top">
                      <Image src="/images/ui/profile.svg"></Image>
                      <div className="profile-dropdown__info">
                        <div className="profile-dropdown__info-top">
                          <span className="profile-dropdown__name">
                            {userName}
                          </span>
                          <span className="profile-dropdown__role">
                            {(isGlobalAdmin && !isGlobalOperations && !isPreferredReportsRole && !isSearchOnlyRole) || isGlobalAdminImpersonating()
                              ? 'Global Admin'
                              : isStoreAdmin
                                ? 'Store Admin' : isGlobalOperations ? 'Global Operations' :
                                  isPreferredReportsRole ? "Preferred Reports Admin" :
                                    isMyFFLRole ? 'FFL Dealer' :
                                      isSearchOnlyRole ? 'Search Only Admin'
                                        : 'Store Agent '}
                          </span>
                        </div>
                        {storeId && (
                          <>
                            {isGlobalAdminImpersonating() ? (
                              <div className="impersonating-info">
                                {IMPERSONATING_INFO}{' '}
                                <span>{storeData?.name}</span>
                              </div>
                            ) : (
                              <span className="profile-dropdown__store_name navigation-wrapper">
                                {storeData?.name || '-'}
                              </span>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {storeId && (
                      <span className="profile-dropdown__store_name hamburger-profile-navigation">
                        {storeData?.name || '-'}
                      </span>
                    )}
                    <hr className="hamburger-profile-divider" />
                    {!isMyFFLRole && (
                      <>
                        <Box className="hamburger-profile-navigation">
                          <Navigation
                            isGlobalAdmin={isGlobalAdmin}
                            isGlobalOperations={isGlobalOperations}
                            isStoreAdmin={isStoreAdmin}
                            isGlobalAdminRole={isGlobalAdminRole}
                            onClick={menuOnClose}
                            userPermissions={userPermissions}
                            isStoreAgent={isStoreAgent}
                          />
                        </Box>
                        <hr className="hamburger-profile-navigation-divider" />
                      </>
                    )}
                    <div className="profile-dropdown__bottom">
                      <ul className="profile-dropdown__menu">
                        {profileMenu.map((menuItem, index) => (
                          <li
                            className="profile-dropdown__menu-item"
                            onClick={menuItem.onClick}
                            key={index}
                          >
                            <Image src={menuItem.imageSrc}></Image>
                            <span>{menuItem.label}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </MenuList>
              </Menu>
            </HStack>
            {/* ) : ( */}
            {/* <IconButton
                variant="ghost-on-accent"
                icon={<FiMenu fontSize="1.25rem" />}
                aria-label="Open Menu"
              /> */}
            {/* )} */}
          </Flex>
        </Container>
      </Box>
      {isOpen && isStoreAdmin && (
        <ProfileModal isOpen={isOpen} onClose={onClose} />
      )}
      {isOpen && isGlobalAdmin && (
        <CreateStore isOpen={isOpen} onClose={onClose} />
      )}
      {isOpenStoreChange && (
        <StoreChangeModal isOpen={isOpenStoreChange} selectedStoreVal={selectedStoreVal} onClose={onCloseStoreChange} />
      )}
    </Box>
  );
}
